import { render } from "./ContactBar.vue?vue&type=template&id=5a1076d3&scoped=true"
import script from "./ContactBar.vue?vue&type=script&lang=js"
export * from "./ContactBar.vue?vue&type=script&lang=js"

import "./ContactBar.vue?vue&type=style&index=0&id=5a1076d3&lang=css"
import "./ContactBar.vue?vue&type=style&index=1&id=5a1076d3&lang=scss&scoped=true"

import exportComponent from "/Users/huangli/Desktop/未命名文件夹 2/borun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1076d3"]])

export default __exports__